"use client";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import UserService from "@/services/api/UserService";

import { loginAfterAuthSuccess } from "@/helpers/auth";
import { useDispatch } from "react-redux";
import { useRouter } from "next/navigation";
import ForgetStepForm from "./components/PasswordStepForm";
import PasswordStepForm from "./components/PasswordStepForm";
import RegisterStepPhone from "@/components/common/drawer/AuthDrawer/components/Step/RegisterStepPhone";
import RegisterStepOtp from "@/components/common/drawer/AuthDrawer/components/Step/RegisterStepOtp";
import CommonImage from "@/components/common/image/CommonImage";
import { FaCirclePlay } from "react-icons/fa6";
import { closeDrawer } from "@/redux/slices/authDrawerSlice";
import { MdKeyboardArrowRight } from "react-icons/md";
import dynamic from "next/dynamic";
import Link from "next/link";
import Image from "next/image";
import AuthDrawer from "@/components/common/drawer/AuthDrawer/AuthDrawer";
import { useSelector } from "react-redux";
import YoutubePlayer from "@/components/common/Player/YoutubePlayer";

const Modal = dynamic(() => import('antd/es/modal'), { ssr: false });

const ForgetPassword = ({ setDrawerType, setDrawerOpen }) => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [timeLeft, setTimeLeft] = useState(120);
  const router = useRouter();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);

  const dispatch = useDispatch();
  const setting = useSelector((state) => state.setting.data);

  useEffect(() => {
    if (step !== 2 || timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft, step]);

  const handleSendOtp = async ({ phone }) => {
    try {
      await UserService.sendOtp({ phone_number: phone, type: "forget" });
      setPhone(phone);
      setOtp("");
      toast.success("ওটিপি পাঠানো হয়েছে");
      setTimeLeft(120);
      setStep(2);
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error("ওটিপি পাঠাতে ব্যর্থ হয়েছে");
      }
    }
  };

  const handleResendOtp = async () => {
    try {
      await UserService.sendOtp({ phone_number: phone, type: "forget" });
      toast.success("ওটিপি আবার পাঠানো হয়েছে");
      setTimeLeft(120);
      setOtp("");
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error("ওটিপি পাঠাতে ব্যর্থ হয়েছে");
      }
    }
  };

  const handleVerifyOtp = async () => {
    try {
      await UserService.verifyOtp({ phone_number: phone, otp_code: otp });
      toast.success("ওটিপি যাচাই সফল হয়েছে");
      setStep(3);
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error("ওটিপি যাচাই ব্যর্থ হয়েছে");
      }
    }
  };

  const handleForgetPassword = async (values) => {
    try {
      const payload = { ...values, phone };
      await UserService.forgetPassword(payload);
      toast.success("পাসওয়ার্ড সফলভাবে পুনঃনির্ধারণ করা হয়েছে");
      router.push("/login");
    } catch (error) {
      // console.log("error", error);
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error(" ব্যর্থ হয়েছে");
      }
    }
  };

  useEffect(() => {
    dispatch(closeDrawer());
  }, [dispatch]);

  return (
    <>

      <section className="login_section">
        <div className="login-section-card">
          <div className="container">
            <div className="login-breadcrumb">
              <ul>
                <li>হোম</li>
                <li><MdKeyboardArrowRight className="arrow-icon" /></li>
                <li><Link href={'#'}>পাসওয়ার্ড</Link></li>
              </ul>
            </div>
            <div className="login-title-card">
              <h1 className="title">
                <span className="highlighted">পাসওয়ার্ড পুনঃনির্ধারণ করুন,</span> Focus এর অভিজ্ঞতায় যুক্ত হন</h1>
            </div>
          </div>
          <Image
            src={'/images/admission-icon/login-now.png'}
            alt={'login'}
            width={105}
            height={105}
            className="login_now_icon"
          />
        </div>

         <div className="container">
          <div className="login-page-card">
            <div className="login-registation-card">
              <div className="grid grid-cols-12 gap-6">
                <div className="lg:col-span-5 col-span-12">
                  <div className="video-part">
                    <div className="top-title">
                      <Image
                        src={"/images/admission-icon/login-icon.png"}
                        className="top-icon"
                        alt="Icon"
                        width={11}
                        height={16}
                      />
                      <span className="">
                        পাসওয়ার্ড পুনঃনির্ধারণ
                      </span>
                    </div>
                    <h2 className="second-title">কিভাবে পাসওয়ার্ড পুনঃনির্ধারণ করবেন ?</h2>
                    <div className="login-video-thumbnail">
                      <CommonImage
                        src={
                          setting?.login_video_thumble_url ??
                          "/images/login/login-video-thumbnail.avif"
                        }
                        alt={"Image"}
                        className="login-thumbnail"
                      />
                      <div className="login-playbtn">
                        <button className="play-btn" onClick={showModal}>
                          <FaCirclePlay className="play-icon" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lg:col-span-7 col-span-12">
                  <div className="h-full flex flex-col justify-center"> 

                      <div className="login-form">
                       <>
                        {step === 1 && (
                          <RegisterStepPhone onSubmit={handleSendOtp} />
                        )}
                        {step === 2 && (
                          <RegisterStepOtp
                            otp={otp}
                            setOtp={setOtp}
                            timeLeft={timeLeft}
                            onResend={handleResendOtp}
                            onVerify={handleVerifyOtp}
                            onEditPhone={() => setStep(1)}
                          />
                        )}
                        {step === 3 && (
                          <PasswordStepForm onSubmit={handleForgetPassword} />
                        )}
                      </>
                      </div> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

         <Modal
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          centered
          width={800}
          className="video-modal"
          styles={{
            body: {
              padding: 0,
            },
          }}
          destroyOnHidden
        >
          <div className="aspect-video w-full">
            <YoutubePlayer
              url={isModalOpen ? setting?.login_video_link : null}
            />
          </div>
        </Modal>

        <AuthDrawer />

        
      </section>
    </>
  );
};

export default ForgetPassword;
